import { render, staticRenderFns } from "./notice-default.vue?vue&type=template&id=162ff93b&scoped=true&"
import script from "./notice-default.vue?vue&type=script&lang=js&"
export * from "./notice-default.vue?vue&type=script&lang=js&"
import style0 from "./notice-default.vue?vue&type=style&index=0&id=162ff93b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162ff93b",
  null
  
)

export default component.exports